import { createContext, useEffect, useState } from "react";
import axios from "axios";

import { buildApiUrl } from "../services/api";

const ContactsContext = createContext({
  contacts: [],
  setContacts: () => {},
  loading: true,
});

export const ContactsProvider = ({ children }) => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isCancelled = false;

    const fetchContacts = async () => {
      try {
        const response = await axios.get(buildApiUrl("/server/api/contacts/list"));

        if (!isCancelled && response.data?.contactsList) {
          setContacts(response.data.contactsList);
        }
      } catch (error) {
        console.error("Erreur lors du chargement des contacts:", error);
      } finally {
        if (!isCancelled) {
          setLoading(false);
        }
      }
    };

    fetchContacts();

    return () => {
      isCancelled = true;
    };
  }, []);

  return (
    <ContactsContext.Provider value={{ contacts, setContacts, loading }}>
      {children}
    </ContactsContext.Provider>
  );
};

export default ContactsContext;
